import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import design from "../../../images/concept.jpg";
import concept from "../../../images/analysis.jpg";
import research from "../../../images/research.jpg";

function Concept() {
  const [displayImg, setDisplayImg] = React.useState(concept);

  function changeImage(img) {
    setDisplayImg(img);
  }

  return (
    <Grid container padding={{ xs: "25% 0%", sm: "2% 0%" }}>
      <Grid items sm={12} xs={12} marginBottom={"5%"}>
        <Typography
          variant="h4"
          color="#33E68C"
          fontWeight={800}
          paddingBottom={"1%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#000"
            fontWeight={800}
            variant={"h4"}
          >
            Our {""}
          </Typography>
          Approach
        </Typography>
      </Grid>
      <Grid items sm={4} xs={12}>
        <Box width={"100%"} marginTop={"10%"}>
          <Typography
            variant="body2"
            color="#000"
            textAlign={"left"}
            fontWeight={600}
            data-aos={"fade-up"}
          >
            Strategy
          </Typography>
          <Typography
            variant="h3"
            color="#000"
            textAlign={"left"}
            fontWeight={700}
            data-aos={"fade-up"}
            onMouseOver={() => changeImage(concept)}
            sx={{
              "&:hover": {
                paddingLeft: "3%",
                textDecoration: "underline solid #33E68C 15%",
                cursor: "pointer",
              },
            }}
          >
            Concept
          </Typography>
        </Box>
        <Box width={"100%"} marginTop={"15%"}>
          <Typography
            variant="body2"
            color="#000"
            textAlign={"left"}
            fontWeight={600}
            data-aos={"fade-up"}
          >
            Analysis
          </Typography>
          <Typography
            variant="h3"
            color="#000"
            textAlign={"left"}
            fontWeight={700}
            data-aos={"fade-up"}
            onMouseOver={() => changeImage(research)}
            sx={{
              "&:hover": {
                paddingLeft: "3%",
                textDecoration: "underline solid #33E68C 15%",
                cursor: "pointer",
              },
            }}
          >
            Research
          </Typography>
        </Box>
        <Box width={"100%"} marginTop={"15%"}>
          <Typography
            variant="body2"
            color="#000"
            textAlign={"left"}
            fontWeight={600}
            data-aos={"fade-up"}
          >
            Development
          </Typography>
          <Typography
            variant="h3"
            color="#000"
            textAlign={"left"}
            fontWeight={700}
            data-aos={"fade-up"}
            onMouseOver={() => changeImage(design)}
            sx={{
              "&:hover": {
                paddingLeft: "3%",
                textDecoration: "underline solid #33E68C 15%",
                cursor: "pointer",
              },
            }}
          >
            Design
          </Typography>
        </Box>
      </Grid>
      <Grid items sm={8} xs={12} marginTop={{ xs: "15%", sm: "0%" }}>
        <Box
          component="img"
          height={{ xs: "30vh", sm: "75vh" }}
          data-aos={"fade-down"}
          id="display-img"
          sx={{
            position: "relative",
            overflow: "hidden",
            width: "100%",
          }}
          src={displayImg}
          alt={"concept"}
        />
      </Grid>
    </Grid>
  );
}

export default Concept;
